export const rowHeight = 50;
export const barHeight = 30;
export const columnWidth = 90;
